<div>
	<!-- CB  -->
	<div class="mb-2 card bg-base-100 w-full shadow-sm">
	  <div class="card-body">
	  	<label for="method-cb" class="payment-item">
	  		<span class="card-title">
		  		<span class="p-1 payment-icon mr-1">
		  			<i class="mr-2 text-3xl fa-regular fa-credit-card"></i>
		  			<i class="mr-2 text-3xl fa-brands fa-cc-mastercard"></i>
		  			<i class="mr-2 text-3xl fa-brands fa-cc-visa"></i>
		  		</span>
		  		<span class="text-xs opacity-60">
		  			CB - MasterCard - Visa
		  		</span> 
		  	</span>
		  	<span>
		  		<input [(ngModel)]="method" id="method-cb" name="method" type="radio" value="cb" class="radio radio-primary"/>
		  	</span>
	  	</label>
	  </div>
  	  <div [ngClass]="{hidden: method()=='paypal'}" #stripeForm></div>
	</div>

	<!-- Paypal  -->
	<div class="mb-2 card bg-base-100 w-full shadow-sm">
	  <div class="card-body">
	  	<label for="method-pp" class="payment-item">
	  		<span class="card-title">
		  		<span class="p-1 payment-icon mr-1">
		  			<img src="img/skin/payment/paypal.png"/>
		  		</span>
		  		<span class="text-xs opacity-60">
		  			Paiement décurisé via PayPal
		  		</span> 
		  	</span>
		  	<span>
		  		<input [(ngModel)]="method" id="method-pp" name="method" type="radio" value="paypal" class="radio radio-primary"/>
		  	</span>
	  	</label>
	  </div>
	</div>
</div>
<span class="my-1 ml-1 text-xs opacity-60">
	<i class="fa-solid fa-lock-keyhole"></i>
	Paiement sécurisé - Données protégées
</span>
<div class="btn-action">
	<button (click)="pay()" class="btn btn-primary btn-gradient my-3" [disabled]="method()==null">
		Payer
		@if(amount()){
			{{amount() | number:'1.2-2':'fr-FR'}}€
		}
	</button>
</div>